/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../unleash";

export const FcsPermissionRevenueDashboard = {
  permission_revenue_dashboard_enable: new FcsFlag.Flag(false),
  permission_customer_dashboard_enable: new FcsFlag.Flag(false),
  permission_revenue_top_commodity_enable: new FcsFlag.Flag(true)
};

export function initFlagsPermissionRevenueDashboard() {
  FcsFlag.register("featureRevenueDashboard", FcsPermissionRevenueDashboard);
}
